(() => {
  const cleanDescription = root => {
    root.querySelectorAll('.mm-product-description .hdt-rte').forEach(source => {
      if (source.dataset.mmdEnhanced) return;
      source.dataset.mmdEnhanced = 'true';
      source.querySelectorAll('p').forEach(p => {
        if (!p.textContent.replace(/\u00a0/g, ' ').trim() && !p.querySelector('img,video,iframe,svg,audio,button,input')) p.remove();
      });
      if (source.querySelector('details')) return;
      let headings = Array.from(source.children).filter(el => el.tagName === 'H2');
      if (headings.length < 2) headings = Array.from(source.children).filter(el => el.tagName === 'H3');
      if (headings.length < 3) return;
      headings.forEach((heading, index) => {
        if (!heading.parentNode || heading.closest('details')) return;
        const group = document.createElement('details');
        group.className = 'mmd-description-group';
        group.open = index === 0 || /specification|included|package|dimension/i.test(heading.textContent);
        const summary = document.createElement('summary');
        summary.textContent = heading.textContent;
        const body = document.createElement('div');
        body.className = 'mmd-description-group__body';
        heading.before(group);
        group.append(summary, body);
        let next = heading.nextSibling;
        while (next && !headings.includes(next)) {
          const current = next;
          next = next.nextSibling;
          body.append(current);
        }
        heading.remove();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => cleanDescription(document), {once:true});
  else cleanDescription(document);
  document.addEventListener('shopify:section:load', event => cleanDescription(event.target));
})();
